<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  mounted() {
    if (this._isMobile()) {
      // 跳转至手机端路由
      // alert("手机端");
      this.$router.replace("/PmdHome");
    } else {
      // 跳转至 pc 端路由
      // alert("pc端");
      this.$router.replace("/PcHome");
    }
  },
  methods: {
    _isMobile() {
      console.log("navigator.userAgent",navigator.userAgent)
      let flag = navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
}
</script>

<style>
  html,
  body,
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    /*overflow-x: hidden;*/
  }
</style>
